import React, { useEffect, useState } from 'react';
import styles from './fabriciohtaveira.module.scss';
import ImageLink1 from './src/1.png';
import ImageLink2 from './src/2.png';
import ImageLink3 from './src/3.png';
import ImageLink4 from './src/4.png';
import { Link } from 'react-router-dom';

const Fabriciohtaveira: React.FC = () => {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 50);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className={styles.fabriciohtaveira}>
            <div className={styles.container}>
                <div className={`${styles.background} ${scrolled ? styles.blurred : ''}`} />
                <div className={styles.principalContent}>
                    <div className={styles.content}>
                        <h1 className="mb-2">Seja bem-vindo(a)!</h1>
                        <p className={`${styles.textBlack} mb-2`}><b>Essa página tem todos os links que você precisa para prosseguir.</b></p>
                        <p><b>Clique no destino desejado!</b></p>
                        <div className={styles.linksContainer}>
                            <a
                                href="http://fabriciotaveira.com.br/"
                                target="_blank"
                                className={styles.link}>
                                <img src={ImageLink1} alt="Link 1" />
                            </a>
                            <a
                                href="http://fabriciotaveira.com.br/"
                                target="_blank"
                                className={styles.link}>
                                <img src={ImageLink2} alt="Link 2" />
                            </a>
                            <a
                                href="http://fabriciotaveira.com.br/"
                                target="_blank"
                                className={styles.link}>
                                <img src={ImageLink3} alt="Link 3" />
                            </a>
                            <a
                                href="http://fabriciotaveira.com.br/"
                                target="_blank"
                                className={`${styles.link} mb-4`}>
                                <img src={ImageLink4} alt="Link 4" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Fabriciohtaveira;